var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('information-card',{attrs:{"sub-title":"Descripción","title":"MODELO DIRECTRIZ"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c8e327","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/guideline-model-instructions.vue
// module id = 1915
// module chunks = 10